import {Component, forwardRef} from "@angular/core";
import {SearchModel} from "@fedeltapointofsale/data-client";
import {FUIAlertAction, FUIAlertActions, FUIAlertService} from "@fedeltapointofsale/ui";
import {AnalyticsService} from "../../../analytics/analytics.service";
import {
    SearchAction,
    SearchActionSelector
} from "../../../framework/entity/search/search-grid/actions/search-action.component";
import {AnalyticEvent} from "../../../analytics/analytic-event";
import {AccountPaymentAction, AccountPaymentVoidService} from "../account-payment-void.service";
import {firstValueFrom} from "rxjs";

/**
 * SearchAction to void account payments
 */
@Component({
    selector: "wbo-void-account-payment-search-action",
    template: "",
    providers: [
        {
            provide: SearchActionSelector,
            useExisting: forwardRef(() => VoidAccountPaymentSearchActionComponent),
            multi: true
        },
        AccountPaymentVoidService
    ]

})
export class VoidAccountPaymentSearchActionComponent implements SearchAction {

    constructor(private alertService: FUIAlertService,
                private voidService: AccountPaymentVoidService,
                private searchModel: SearchModel<any>,
                private analyticsService: AnalyticsService) {
    }

    /**
     *
     * @returns {number}
     */
    getImportance(): number {
        return 50;
    }

    /**
     *
     * @param data
     * @returns {string}
     */
    getIcon(data: any): string {
        return "delete";
    }

    getIconClass(data: any): string {
        return "";
    }

    getIconSize(data: any): number {
        return 17;
    }

    getName(data: any): string {
        return "wbo.account-payment.search.action.void";
    }

    async doAction(data: any): Promise<void> {
        const action: FUIAlertAction = await firstValueFrom(this.alertService.showConfirmationOkCancel("wbo.account-payment.search.prompt.void.heading", "wbo.account-payment.search.prompt.void.message"));
        if (action === FUIAlertActions.OK_ACTION) {
            this.analyticsService.trackEvent(AnalyticEvent.SEARCH_DELETE_ROW, this.searchModel);
            return this.voidService.performAction(new AccountPaymentAction(data["accountId"], data["receiptNo"]));
        }
        return undefined;
    }

    isAvailable(data: any): boolean {
        return data["status"] !== "Voided" && data["type"].trim() !== "Void" && data["receiptNo"];
    }
}
